import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Selfapp() {
  return (
    <section className="mobiuscase p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="order-2 order-md-1 mt-4 mt-md-0"
          >
            <StaticImage
              src="../../../images/landing/software-development/self-app.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={840}
              height={506}
            />
          </Col>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="order-1 order-md-2 my-auto offset-md-1"
          >
            <h2>The S.E.L.F App</h2>
            <p>
              The S.E.L.F App by Project Impact MS is another leap towards a
              utopian future where educational organizations can seamlessly
              operate, improve enrollment, save time, communicate with the
              students beyond the classroom, and monitor the level of emotional
              intelligence
            </p>
            <Link
              to="/case-studies/impact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              View Case Study
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Selfapp;
